import React, { useEffect, useState } from "react";
import { Button, Drawer, Form, TimePicker, DatePicker, message } from "antd";
import dayjs from "dayjs";
import service from "../../api/FetchInterceptor";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

dayjs.extend(isSameOrBefore);

const AddAvailability = ({ id = null, open, setOpen, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const isEdit = !!id;

    const loadAvailability = () => {
        if (!id) return;

        setLoading(true);
        service({ method: "GET", url: `admin/availabilities/${id}` })
            .then((res) => {
                const data = res.data ?? res;

                form.setFieldsValue({
                    date: data.date ? dayjs(data.date, "YYYY-MM-DD") : null,
                    start_time: data.start_time ? dayjs(data.start_time, "HH:mm") : null,
                    end_time: data.end_time ? dayjs(data.end_time, "HH:mm") : null,
                });
            })
            .catch(() => message.error("Erreur chargement disponibilité"))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (!open) {
            form.resetFields();
            return;
        }

        if (isEdit) {
            loadAvailability();
        } else {
            form.resetFields();
            form.setFieldsValue({
                date: dayjs(),
                start_time: dayjs("09:00", "HH:mm"),
                end_time: dayjs("18:00", "HH:mm"),
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, id]);

    const onSubmit = (values) => {
        const start = values.start_time;
        const end = values.end_time;

        if (start && end && end.isSameOrBefore(start)) {
            message.error("L'heure de fin doit être après l'heure de début");
            return;
        }

        const payload = {
            date: values.date?.format("YYYY-MM-DD"),
            start_time: values.start_time?.format("HH:mm"),
            end_time: values.end_time?.format("HH:mm"),
        };

        setLoading(true);
        service({
            method: isEdit ? "PUT" : "POST",
            url: isEdit ? `admin/availabilities/${id}` : "admin/availabilities",
            data: payload,
        })
            .then((res) => {
                const data = res.data ?? res;
                message.success(data.message ?? "Enregistré");
                setOpen(false);
                form.resetFields();
                onSuccess?.();
            })
            .catch(() => message.error("Erreur lors de l'enregistrement"))
            .finally(() => setLoading(false));
    };

    return (
        <Drawer
            title={isEdit ? "Modifier une disponibilité" : "Ajouter une disponibilité"}
            open={open}
            onClose={() => setOpen(false)}
            width={520}
            destroyOnClose
        >
            <Form form={form} layout="vertical" onFinish={onSubmit}>
                <Form.Item name="date" label="Date" rules={[{ required: true }]}>
                    <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
                </Form.Item>

                <Form.Item name="start_time" label="Heure début" rules={[{ required: true }]}>
                    <TimePicker style={{ width: "100%" }} format="HH:mm" />
                </Form.Item>

                <Form.Item name="end_time" label="Heure fin" rules={[{ required: true }]}>
                    <TimePicker style={{ width: "100%" }} format="HH:mm" />
                </Form.Item>

                <Button loading={loading} type="primary" htmlType="submit" block>
                    {isEdit ? "Modifier" : "Enregistrer"}
                </Button>
            </Form>
        </Drawer>
    );
};

export default AddAvailability;
